<template>
  <div class="table-responsive margin-top-1-perc">
    <table class="table table-striped">
      <thead>
        <tr>
          <th v-for="(key,index) in columns" 
            @click="sortBy(key.ColumnName)"
            :class="{ active: sortKey == key.ColumnName }" class="text-align-center border-right" :key="index">
            {{ key.ColumnAlias | capitalize }}
            <span class="arrow" :class="checkSortable(key.ColumnName) == true ? (sortOrders[key.ColumnName] > 0 ? 'asc' : 'dsc') : 'none'">
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(entry,index) in filteredData" class="" :key="index">
          <td v-for="(key,index) in columns" class="border-right" :key="index">
            <span v-if="isLinkColumn(key.ColumnName)" class="text-decoration-underline text-color-blue cursor-pointer" @click="updateDetails($event,key.ColumnName,entry)">
              <!-- <a href=""> {{entry[key.ColumnName]}}</a>   -->
              {{entry[key.ColumnName]}}
            </span>
            <span v-else>
              {{ key.ColumnName === 'ProgressPercent' || key.ColumnName === 'MobileProgress' || key.ColumnName === 'WebProgress' || key.ColumnName === 'ViewProgress' ? entry[key.ColumnName] + '%' : entry[key.ColumnName]}}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="row margin-Top-2Perc"> 
      <div class="col-md-12 col-lg-12 width1 margin-left-1point6Perc">
        <user-progress-discussion-sublist-overlay v-if="showDisscussonOverlay" @showOverlay="closeOverlay" v-bind:selectedUserProgressObj="selectedUserProgressObj" v-bind:discussionResp="discussionResp"></user-progress-discussion-sublist-overlay>
      </div>
    </div>
    <div class="row margin-Top-2Perc"> 
      <div class="col-md-12 col-lg-12 width2 margin-left-1point6Perc">
        <user-progress-challenge-sublist-overlay v-if="showChallengesTakenOverlay" @showOverlay="closeOverlay" v-bind:selectedUserProgressObj="selectedUserProgressObj" v-bind:challengesTakenResp="challengesTakenResp"></user-progress-challenge-sublist-overlay>
      </div>
    </div>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <loader></loader>
  </div>  
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import UserProgressDiscussionSublistOverlay from '@/components/UserProgressDiscussionSublistOverlay'
import UserProgressChallengeSublistOverlay from '@/components/UserProgressChallengeSublistOverlay'
import { reportService } from '@/server-util/report-service'
import AlertBox from '@/components/AlertOverlay'
import { constants } from '@/utils/constants'
export default {
  props: {
    data: Array,
    columns: Array,
    sortColumns: Array,
    filterKey: String,
    linkColumns: Array
  },
  data: function () {
    if (this.data === undefined || this.data === null) {
      return
    }
    var sortOrders = {}
    /* this.columns.forEach(function (key) {
      sortOrders[key] = 1
    }) */
    this.sortColumns.forEach(function (key) {
      sortOrders[key] = 1
    })
    return {
      sortKey: '',
      sortOrders: sortOrders,
      selectedUserProgressObj: null,
      showDisscussonOverlay: false,
      showChallengesTakenOverlay: false,
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      discussionResp: [],
      challengesTakenResp: []
    }
  },
  components: {
    'user-progress-discussion-sublist-overlay': UserProgressDiscussionSublistOverlay,
    'user-progress-challenge-sublist-overlay': UserProgressChallengeSublistOverlay,
    'alert-box': AlertBox,
    'loader': Loader
  },
  computed: {
    filteredData: function () {
      var sortKey = this.sortKey
      var filterKey = this.filterKey && this.filterKey.toLowerCase()
      var order = this.sortOrders[sortKey] || 1
      var data = this.data
      if (filterKey) {
        data = data.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
      if (sortKey) {
        data = data.slice().sort(function (a, b) {
          a = a[sortKey]
          b = b[sortKey]
          return (a === b ? 0 : a > b ? 1 : -1) * order
        })
      }
      return data
    }
  },
  filters: {
    capitalize: function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    }
  },
  methods: {
    closeOverlay (value) {
      // AK: When user pressed close then close discussion overlay
      this.showDisscussonOverlay = value
      this.showChallengesTakenOverlay = value
      this.$store.state.isOverlayVisible = value
    },
    updateDetails: function (event, clickedLinkColumnName, selectedObj) {
      // AK: Store selected Userr progress Obj
      this.selectedUserProgressObj = selectedObj
      // AK: case name must be same as declared in User Progress LinkedColumn name
      switch (clickedLinkColumnName) {
        case 'DiscussionPosts':
          // console.log('DiscussionPosts clicked >>> ' + JSON.stringify(this.selectedUserProgressObj))
          // AK: First check count of Discussion post
          if (this.selectedUserProgressObj.DiscussionPosts > 0) {
            this.getDiscussionPost()
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Discussion post(s) not available.'
          }
          break
        case 'ChallengesTaken':
          // console.log('ChallengesTaken clicked >>> ' + JSON.stringify(this.selectedUserProgressObj))
          if (this.selectedUserProgressObj.ChallengesTaken > 0) {
            // this.showChallengesTakenOverlay = true
            this.getChallengesTaken()
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'No challenges yet taken by \'' + this.selectedUserProgressObj.UserFullName + '\'.'
          }
          break
      }
    },
    sortBy: function (key) {
      console.log('SORT KEY : ' + key)
      console.log('SORT COLUMNS : ' + this.sortColumns.indexOf(key))
      if (this.sortColumns.indexOf(key) > -1) {
        this.sortKey = key
        this.sortOrders[key] = this.sortOrders[key] * -1
      }
    },
    checkSortable: function (key) {
      return this.sortColumns.indexOf(key) > -1
    },
    isLinkColumn: function (key) {
      return this.linkColumns.indexOf(key) > -1
    },
    getDiscussionPost: function () {
      var storeObj = this.$store
      var _this = this
      if (this.selectedUserProgressObj.UserCourseId !== null || this.selectedUserProgressObj.UserCourseId !== undefined || this.selectedUserProgressObj.UserCourseId !== '') {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        reportService.getDiscussionPosts(storeObj.state.access_token, _this.selectedUserProgressObj.UserCourseId).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recievinglist
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              _this.discussionResp = responseObj.data
              console.log(JSON.stringify(_this.discussionResp))
              _this.showDisscussonOverlay = true
              _this.$store.state.isOverlayVisible = true
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('UserCourseId ID is NULL hence declined LOADING Discussion Post')
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    getChallengesTaken: function () {
      var storeObj = this.$store
      var _this = this
      if (this.selectedUserProgressObj.UserCourseId !== null || this.selectedUserProgressObj.UserCourseId !== undefined || this.selectedUserProgressObj.UserCourseId !== '') {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        reportService.getChallengesTaken(storeObj.state.access_token, _this.selectedUserProgressObj.UserCourseId).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              _this.challengesTakenResp = responseObj.data
              // console.log('getChallengesTaken >>> ' + JSON.stringify(_this.challengesTakenResp))
              _this.bindTLQResp()
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('UserCourseId ID is NULL hence declined LOADING Challenges Taken.')
      }
    },
    bindTLQResp: function () {
      this.tempChallengesTakenResp = []
      this.challengesTakenResp.forEach((obj) => {
        if (parseInt(obj.ResponseType) === parseInt(constants.ResponseType.Audio)) {
          obj.ResponseAudioUrl = obj.ResponseVideoUrl
          obj.ResponseVideoUrl = null
        } else if (parseInt(obj.ResponseType) === parseInt(constants.ResponseType.Text)) {
          obj.ResponseAudioUrl = null
          obj.ResponseVideoUrl = null
        } else {
          obj.ResponseAudioUrl = null
          obj.ResponseVideoUrl = obj.ResponseVideoUrl
        }
      })
      // console.log('bindTLQResp Server Response >>> ' + JSON.stringify(this.challengesTakenResp))
      for (var i = 0; i < this.challengesTakenResp.length; i++) {
        var obj = {
          ChallengeTitle: this.challengesTakenResp[i].ChallengeTitle,
          ResponseVideoUrl: this.challengesTakenResp[i].ResponseVideoUrl,
          ResponseText: this.challengesTakenResp[i].ResponseText,
          ResponseAudioUrl: this.challengesTakenResp[i].ResponseAudioUrl,
          FeedbackScore1: this.challengesTakenResp[i].FeedbackScore1,
          FeedbackScore2: this.challengesTakenResp[i].FeedbackScore2,
          FeedbackScore3: this.challengesTakenResp[i].FeedbackScore3,
          AverageP2PScore: this.challengesTakenResp[i].AverageP2PScore,
          AverageScore: '', // this.challengesTakenResp[i].AverageScore,
          FeedbackReceived: this.challengesTakenResp[i].FeedbackReceived,
          FeedbackGiven: this.challengesTakenResp[i].FeedbackGiven,
          FeedbackReviewed: this.challengesTakenResp[i].FeedbackReviewed,
          TrafficLightScore: '',
          OverallP2PScore: this.challengesTakenResp[i].FeedbackScore1 + ' ' + this.challengesTakenResp[i].FeedbackScore2 + ' ' + this.challengesTakenResp[i].FeedbackScore3
        }
        for (var j = 0; j < this.challengesTakenResp[i].TrafficLightScore.length; j++) {
          obj.TrafficLightScore += '<b>' + this.challengesTakenResp[i].TrafficLightScore[j].Technique + ':</b>  ' + this.challengesTakenResp[i].TrafficLightScore[j].Scores + '<br/> ' // (' + this.challengesTakenResp[i].TrafficLightScore[j].AvgScore + ') '
          obj.AverageScore += this.challengesTakenResp[i].TrafficLightScore[j].AvgScore + '<br/>'
        }
        this.tempChallengesTakenResp.push(obj)
      }
      this.challengesTakenResp = this.tempChallengesTakenResp
      // console.log('bindTLQResp >>> ' + JSON.stringify(this.tempChallengesTakenResp))
      this.showChallengesTakenOverlay = true
      this.$store.state.isOverlayVisible = true
    }
  }
}
</script>
<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* table {
  border: 2px solid #f39c12;
  border-radius: 3px;
  background-color: #fff;
}

th {
  background-color: #f39c12;
  color: rgba(255,255,255,0.66);
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

td {
  background-color: #f9f9f9;
}

th, td {
  min-width: 120px;
  padding: 10px 20px;
}

th.active {
  color: #fff;
}

th.active .arrow {
  opacity: 1;
} */
.cursor-pointer{
  cursor: pointer;
}
.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #000;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #000;
}

.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}

.arrow.none{
  display: none;
}
.text-decoration-underline {
  text-decoration: underline;
}
.text-color-blue {
  color: blue;
}
.text-align-center{
  text-align: center !important;
}
.border-right{
    border-right: 1px solid #aaa !important;
}
.width{
  width: 50% !important;
}
.border-red{
  border: 1px solid red;
}
</style>





// WEBPACK FOOTER //
// src/components/SortableGridForUserProgress.vue